<div class="overlay" #overlay>
  <div class="spinner">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</div>
